// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';

export const addressFloorTaggingActions = {
  GET_HIGHER_FLOOR_VAS_DATA: 'GET_HIGHER_FLOOR_VAS_DATA',
  UPDATE_PAGE_NUMBER: 'UPDATE_PAGE_NUMBER',
  UPDATE_PENDING_TASK_COUNT: 'UPDATE_PENDING_TASK_COUNT',
  UPDATE_FILTER: 'UPDATE_FILTER',
  GET_PO_DETAILS: 'GET_PO_DETAILS'
};

export const getAllHigherFloorVasAction = payload => ({
  type: addressFloorTaggingActions.GET_HIGHER_FLOOR_VAS_DATA,
  payload
});

export const updatePageNumber = payload => ({
  type: addressFloorTaggingActions.UPDATE_PAGE_NUMBER,
  payload
});

export const updatePendingTaskCount = payload => ({
  type: addressFloorTaggingActions.UPDATE_PENDING_TASK_COUNT,
  payload
});

export const updateFilter = (key, payload) => ({
  type: addressFloorTaggingActions.UPDATE_FILTER,
  key,
  payload
});

export const getAllHigherFloorVas = () => (dispatch, getState) => {
  const { addressFloorTaggingState } = getState();
  dispatch(
    getAllHigherFloorVasAction({
      isLoading: true,
      isLoaded: false
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getAllHigherFloorVasEntity',
    method: 'GET',
    replaceParamsArr: [
      {
        key: 'entityType',
        val: 'PICKUP'
      },
      {
        key: 'entityType',
        val: 'DRS'
      },
      {
        key: 'status',
        val: 'PENDING'
      },
      {
        key: 'clientId',
        val:
          addressFloorTaggingState.filters.client &&
          addressFloorTaggingState.filters.client.id
      },
      { key: 'pageNumber', val: addressFloorTaggingState.pageNumber },
      { key: 'pageSize', val: addressFloorTaggingState.pageSize }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getAllHigherFloorVasAction({
            isLoading: false,
            isLoaded: true,
            taskboardData: res.payload || [],
            totalElements: res.totalElements
          })
        );
      } else {
        dispatch(
          getAllHigherFloorVasAction({
            isLoading: false,
            isLoaded: true,
            taskboardData: [],
            totalElements: 0
          })
        );
      }
    },
    failureCb: res => {
      dispatch(
        getAllHigherFloorVasAction({
          isLoading: false,
          isLoaded: true,
          taskboardData: [],
          totalElements: 0
        })
      );
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get tasks'
      );
    },
    catchCb: res => {
      dispatch(
        getAllHigherFloorVasAction({
          isLoading: false,
          isLoaded: true,
          taskboardData: [],
          totalElements: 0
        })
      );
      toastr.error('Something went wrong!', 'Could not get tasks');
    }
  };

  return makeApiCall(requestObj);
};
export const changeTaskStatus = (row, newStatus) => dispatch => {
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'changeHigherFloorVasStatus',
    method: 'PUT',
    pathVariables: [{ key: '{status}', val: newStatus }],
    replaceParamsArr: [
      {
        key: 'entityId',
        val: row.pickupOrDrsId
      },
      {
        key: 'entityType',
        val: row.activityType
      },
      {
        key: 'clientAddressId',
        val: row.clientAddressId
      }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(getAllHigherFloorVas());
        toastr.success('Success', `Changed task status to ${newStatus}`);
      }
    },
    failureCb: res => {
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to APPROVE/REJECT appointment.'
      );
    },
    catchCb: res => {
      toastr.error(
        'Something went wrong!',
        'Unable to APPROVE/REJECT appointment.'
      );
    }
  };

  return makeApiCall(requestObj);
};

export const bulkUploadAppointment = (file, onSuccess) => dispatch => {
  if (!file) {
    toastr.error('Error!', 'Please select a file.');
    return null;
  }

  const formData = new FormData();
  formData.append('file', file);

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'bulkUploadHigherFloorVas',
    method: 'POST',
    postFormData: true,
    data: formData,
    contentType: '',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(getAllHigherFloorVas());
        toastr.success('Success', res.payload || 'Upload successfully');
        onSuccess(null);
      }
    },
    failureCb: res => {
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Unable to bulk upload consignment appointment.'
      );
    },
    catchCb: res => {
      toastr.error(
        'Something went wrong!',
        'Unable to bulk upload consignment appointment.'
      );
    }
  };

  return makeApiCall(requestObj);
};
